<template>
  <div class="card-carousel-slider">
    <div class="card-carousel-header">
      <div class="col-xs-12 col-md-6">
        <h2 id="titleText" class="card-carousel-slider__title heading-xl">{{ slides.title }}</h2>
      </div>
      <div class="col-xs-12 card-carousel-slider__see-all-link">
        <a :href="slides.seealllink">{{ slides.seealltext }}</a>
      </div>
    </div>
    <div class="card-carousel-content">
      <div class="col-xs-12 col-md-3">
        <p class="card-carousel-slider__description text-body">
          {{ slides.description }}
        </p>
      </div>
      <div class="col-xs-12 col-md-9">
        <div class="card-carousel-slider__content card-carousel-slider__content--category">
          <template v-if="useCarousel">
            <carousel
              :speed="600"
              :per-page="1"
              :vertical="false"
              :pagination-enabled="false"
              :navigation-enabled="true"
            >
              <slide
                v-for="(slide, slideIndex) in slides.slide"
                :key="slideIndex"
                class="card-carousel-slider__slide"
              >
                <a v-tag="slide.taggingclick" :href="slide.sliderlink" class="carousel-card__link">
                  <div class="carousel-card__thumbnail carousel-card__large">
                    <img
                      class="card-carousel-media-gallery__item-img-element lazyloaded"
                      :src="slide.sliderimage"
                      alt="Slide"
                      @click="slide.sliderlink"
                    />
                  </div>
                  <div class="carousel-card__heading">
                    <h3 class="heading-md-em mb-xxs">{{ slide.slidertitle }}</h3>
                  </div>
                </a>
              </slide>
            </carousel>
          </template>
          <template v-else>
            <carousel :speed="600" :per-page="4" :navigation-enabled="true">
              <slide
                v-for="(slide, slideIndex) in slides.slide"
                :key="slideIndex"
                class="card-carousel-slider__slide"
              >
                <a v-tag="slide.taggingclick" :href="slide.sliderlink" class="carousel-card__link">
                  <div class="carousel-card__thumbnail carousel-card__large">
                    <img
                      class="card-carousel-media-gallery__item-img-element lazyloaded"
                      :src="slide.sliderimage"
                      alt="Slide"
                      @click="slide.sliderlink"
                    />
                  </div>
                  <div class="carousel-card__heading">
                    <h3 class="heading-md-em mb-xxs">{{ slide.slidertitle }}</h3>
                  </div>
                </a>
              </slide>
            </carousel>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-slider',
  props: {
    slides: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      useCarousel: window.ScreenSizeHandler
        ? window.ScreenSizeHandler.getMqForSize('small').selected
        : true,
    };
  },
};
</script>
